<template>
  <div class="block-aff">
    <p class="quote">
      {{ chunk.Testimonial }}
    </p>
    <div v-if="chunk.Media">
      <img class="float-right" :src="'https://cms-legacy.games.bitcoin.com' + chunk.Media.url" />
    </div>
    <p class="company">
      <a :href="chunk.Url" target="_blank">
        {{ chunk.Affiliate }}
      </a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    chunk: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style>
p.company {
  position: absolute;
  bottom: 10px;
}
</style>
